import { render, staticRenderFns } from "./PT041CategoryShowParts.vue?vue&type=template&id=d2c7338c&"
import script from "./PT041CategoryShowParts.vue?vue&type=script&lang=js&"
export * from "./PT041CategoryShowParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports